/**
 * Created by guoliangfang on 2017/9/6.
 */
import React from 'react';
import abortAjaxHoc from 'components/abortAjaxHoc';
import {Tree, Popover,Icon} from 'antd';
import './index.less';
const TreeNode = Tree.TreeNode;

class AuthBrief extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            auth_brief:[],
            loading:true
        };
    }

    static refactorArrayToTree(data, pid) {
        const parent_id = pid || 0;
        const left_data = [];
        const parent = data.filter((item) => {
            if (parent_id == item.pid) {
                return item;
            } else {
                left_data.push(item);
            }
        });
        if (parent.length > 0) {
            return parent.map((item) => {
                const left = left_data.filter((left) => {
                    return left.pid == item.id;
                });
                if (left.length > 0) {
                    item.children = [...AuthBrief.refactorArrayToTree(left_data, item.id)];
                    return item;
                } else {
                    return item;
                }
            });
        }
    }

    componentDidMount() {
        //'/auth/permission/brief'
        this.props.abortableAjax('GET','/auth/permission/brief').then(res=>{
            this.setState({auth_brief:res.data,loading:false});
        });
    }

    getTreeNode(data) {
        if (!data) {
            return;
        }
        return data.map((item) => {
            const children = item.granted_sub_account.map((child) => {
                return <span className="authBrief-children" key={child.id}>{child.name}</span>;
            });
            const title = (
                <Popover
                    content={<div className="authBrief-popover">{children}</div>}
                    title="Permissions have been granted to the following sub-accounts"
                    trigger="click"
                    placement="right"
                    autoAdjustOverflow={false}
                    getPopupContainer={() => document.querySelector('#authBrief')}
                >
                    <span>
                        {item.display_name}({item.granted_sub_account?item.granted_sub_account.length:0}) users
                    </span>
                </Popover>
            );
            return (
                <TreeNode icon={<Icon type="lock" />} title={title} key={item.id}>
                    {this.getTreeNode(item.children)}
                </TreeNode>
            );
        });
    }

    onSelect() {

    }

    render() {
        let authTree;
        const {auth_brief} = this.state;
        if (auth_brief) {
            const treeData = AuthBrief.refactorArrayToTree(auth_brief);
            const treeNote = this.getTreeNode(treeData);
            authTree =
                <Tree
                    showIcon
                    defaultExpandAll
                >
                    {treeNote}
                </Tree>;
        }
        return (
            <div id="authBrief">
                <p className="sub-account-tips">The authorization status of each permission point is as follows (the number represents the number of authorized sub-accounts)</p>
                {authTree}
            </div>
        );
    }
}

export default abortAjaxHoc(AuthBrief);



// WEBPACK FOOTER //
// ./src/pages/SubAccountManagement/AuthBrief/index.js